<template>
  <v-app
    id="app"
    :class="
      `${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`
    "
  >
    <router-view />

    <PageRedirectLoaderDialog />

    <PageLoaderDialog />

    <AutofillReviewNoticeDialog
      v-model="show_review_notice"
      :fields="review_fields"
    />
  </v-app>
</template>

<script>
import EventBus from "@/eventBus";
import PageRedirectLoaderDialog from "@/components/Dialogs/PageRedirectLoaderDialog";
import PageLoaderDialog from "@/components/Dialogs/PageLoaderDialog.vue";
import AutofillReviewNoticeDialog from "@/views/CreateProject/Steps/UploadStep/Dialogs/AutofillReviewNoticeDialog";
import { Logger } from "@/helpers/logger";

export default {
  name: "App",
  components: {
    PageRedirectLoaderDialog,
    PageLoaderDialog,
    AutofillReviewNoticeDialog
  },
  data() {
    return {
      project_type_notifications: [1, 6, 9, 10, 11, 12, 13, 14, 18],
      background_autofill_active: false,
      show_review_notice: false,
      review_fields: []
    };
  },
  mounted() {
    EventBus.$on("startAutofillBackground", () => {
      this.background_autofill_active = true;
    });

    EventBus.$on("showAutofillReviewNotice", fields => {
      if (Array.isArray(fields) && fields.length > 0) {
        this.review_fields = fields;
        this.show_review_notice = true;
      }
    });

    EventBus.$on("geocodeAddress", async address => {
      try {
        const google = await this.$gmapApiPromiseLazy();
        const geocoder = new google.maps.Geocoder();
        const { results } = await geocoder.geocode({ address });
        if (!results || !results.length) return;

        const result = results[0];
        const addr_comp = result.address_components;

        const getComp = (type, useLong = false) => {
          const c = addr_comp.find(a => a.types.includes(type));
          if (!c) return null;
          return useLong ? c.long_name : c.short_name;
        };

        const street_number = getComp("street_number");
        const route = getComp("route");
        const address_1 =
          [street_number, route].filter(Boolean).join(" ") || address;

        const possible_cities = {
          locality: getComp("locality"),
          sublocality: getComp("sublocality"),
          neighborhood: getComp("neighborhood"),
          administrative_area_level_3: getComp("administrative_area_level_3")
        };

        this.$store.commit(
          "createProject/SET_POSSIBLE_CITIES",
          possible_cities
        );
        this.$store.commit(
          "createProject/SET_FULL_ADDR",
          result.formatted_address
        );

        const current = this.$store.state.createProject.formdata.location;
        const payload = JSON.parse(JSON.stringify(current));
        payload.address.address_1 = address_1;
        payload.address.state = getComp("administrative_area_level_1");
        payload.address.county = getComp("administrative_area_level_2");
        payload.address.postal_code = getComp("postal_code");
        payload.address.country = getComp("country", true); // long_name to match Places API ("United States" not "US")
        payload.address.latitude = result.geometry.location.lat();
        payload.address.longitude = result.geometry.location.lng();

        this.$store.dispatch(
          "createProject/setFormdataLocationAddress",
          payload
        );
        Logger("Geocoder", result);
      } catch (e) {
        Logger("GeocoderError", e);
      }
    });

    this.$echo
      .channel("pzse.push.notifications")
      .listen(".PzseNotifications", payload => {
        EventBus.$emit("reloadNotifications");

        if (
          this.project_type_notifications.includes(
            payload.notificationVariables.ACTION_TYPE
          )
        ) {
          EventBus.$emit(
            "reloadProject",
            payload.notificationVariables.PROJECT_NUMBER
          );
        }
        Logger("Pusher", payload);
      });

    this.$echo
      .channel("pzse.claude.parser")
      .listen(".PzseClaudeParser", event => {
        Logger("Pusher", event);

        if (!this.background_autofill_active) return;

        this.background_autofill_active = false;

        EventBus.$emit("autofillBackgroundReady", event.payload);
      });
  }
};
</script>

<style lang="scss">
@import "~dropzone/src/dropzone";
@import "./scss/theme";
@import "./assets/fonts/css/satoshi.css";

.theme--light {
  &.v-application {
    background-color: map-get($custom-colors, "alabaster") !important;
  }
}
</style>
